// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"/wp-content/themes/gigazone-gaming/dist/js/webpack-gigazone-gaming": 0,
	"app/content/css/app": 0,
	"wp-content/themes/gigazone-gaming/css/_variables": 0,
	"wp-content/themes/gigazone-gaming/css/_pallet": 0,
	"wp-content/themes/gigazone-gaming/css/_bootstrap_no_grid": 0,
	"wp-content/themes/gigazone-gaming/css/_bootstrap": 0,
	"wp-content/themes/gigazone-gaming/dist/css/virtual-tournament/virtual-tournament": 0,
	"wp-content/themes/gigazone-gaming/dist/css/virtual-tournament/virtual-tournament-extra": 0,
	"app/content/css/roster_basic": 0,
	"app/content/css/roster": 0,
	"app/content/css/fortnite": 0,
	"app/content/css/carousel": 0,
	"app/content/css/admin-roster": 0,
	"app/content/css/_variables": 0,
	"app/content/css/_game_display_variables": 0,
	"wp-content/themes/gigazone-gaming/css/style": 0,
	"wp-content/themes/gigazone-gaming/css/shop": 0,
	"wp-content/themes/gigazone-gaming/css/profile": 0,
	"wp-content/themes/gigazone-gaming/css/gigazone": 0,
	"wp-content/themes/gigazone-gaming/css/dps-layout": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(!/^(app\/content\/css\/(roster(|_basic)|(|_game_display)_variables|admin\-roster|app|carousel|fortnite)|wp\-content\/themes\/gigazone\-gaming\/(css\/(_(bootstrap(|_no_grid)|pallet|variables)|(gigazon|profil|styl)e|dps\-layout|shop)|dist\/css\/virtual\-tournament\/virtual\-tournament(|\-extra)))$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkgigazone_gaming"] = self["webpackChunkgigazone_gaming"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));